'use client';

import { useTranslations } from 'next-intl';
import { CacheKeys, ServerActionName } from '@headless-workspace/config';
import { AsyncData, ResultEmpty, ResultFailure, ResultSuccess } from '@headless-workspace/core-domain';
import { getRecommendedProductsServerAction, RecommendedProductsValue } from '../../../server';
import { useSafeSWR } from '../hooks';

const DEFAULT_ERROR_KEY = 'RECOMMENDED_PRODUCTS_ERROR';

type UseTargetedProductRecommendationsReturnType = AsyncData<RecommendedProductsValue | null>;

export const useTargetedProductRecommendations = (carouselId: string): UseTargetedProductRecommendationsReturnType => {
    const t = useTranslations('Discover.Home.carousel');

    const { data, isLoading, error } = useSafeSWR(
        CacheKeys.ProductRecommendations,
        ServerActionName.getProductRecommendations,
        () => getRecommendedProductsServerAction('homepage'),
    );

    if (!data) {
        if (error) {
            return {
                isLoading,
                result: ResultFailure(
                    DEFAULT_ERROR_KEY,
                    error instanceof Error ? error.message : t('error.productRecommendations'),
                ),
            };
        }

        return { isLoading, result: ResultEmpty() };
    }

    const recommendation = data.type === 'success' ? data.data.find((item) => item.id === carouselId) : undefined;

    return {
        isLoading,
        result: recommendation ? ResultSuccess(recommendation) : ResultEmpty(),
    };
};
